import { useCallback } from 'react';
import { LogManager } from 'Core/logManager';
import { COACH_SSO_LOG_KEY, NAVIGATION_EVENT_TYPE } from '../constants';

const LOG_MESSAGE = `${COACH_SSO_LOG_KEY} navigation`;

// Tells the embedded Coaching app to navigate to a section. The message goes to the iframe
// window held by `frameRef`; nothing is sent (only a `LogManager.warn`) when the frame is not
// mounted yet. `targetOrigin` is `*` as agreed with the Coaching team; the payload carries no
// secrets. A stricter alternative is the origin of `endpoints.COACHING_URL`.
export const useCoachingNavigation = ({ frameRef }) => {
  const navigateTo = useCallback(
    (path) => {
      const frameWindow = frameRef.current?.contentWindow;

      if (!frameWindow) {
        LogManager.warn(`${LOG_MESSAGE} skipped: iframe not available`, { path });
        return;
      }

      frameWindow.postMessage({ eventType: NAVIGATION_EVENT_TYPE, path }, '*');
      LogManager.info(LOG_MESSAGE, { path });
    },
    [frameRef],
  );

  return { navigateTo };
};
